// extracted by mini-css-extract-plugin
export default {"logo":"NavBar_logo__cE4Zm","navbar":"NavBar_navbar__cMXRd","fadeIn":"NavBar_fadeIn__NzF5t"};